import React from 'react';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import Strings from '../../translations/Translations';

export default function ModalAppleMusicAlert(props) {
  const { modalOpen, toggleModal } = props;

  return (
    <Modal isOpen={modalOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>
        {Strings('apple_music_song_selected')}
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col md={12}>
            {Strings('apple_music_song_selected_message')}
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={toggleModal}
        >
          {Strings('OK')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
